import React, { useEffect, useState } from "react";
import { useAppContext } from "../../../../../../context/AppContext";
import UserPageLayout from "../../../../components/UserPageLayout";
import BrokerList from "../../components/BrokerList";
import BrokerForm from "../../components/BrokerForm";

export default function BrokersAdmin() {
    const { setPageTitle, setPageUserID, appData, userAccessData } = useAppContext();
    const [editMode, setEditMode] = useState(false);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [reloadKey, setReloadKey] = useState(false);

    const isBrokersEnabled = Boolean(appData?.metadata?.features?.includes("brokers"));
    const canManageBrokers = Boolean(userAccessData?.super_user && userAccessData?.trusted_user);

    useEffect(() => {
        setPageUserID(null);
        setPageTitle(editMode ? "Broker Editor" : "Brokers");
    }, [editMode, setPageTitle, setPageUserID]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            {!isBrokersEnabled ? (
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div className="alert alert-warning alert-alt solid mb-0">
                                            The brokers module is not enabled for this app.
                                        </div>
                                    </div>
                                </div>
                            ) : !editMode ? (
                                <BrokerList
                                    reloadKey={reloadKey}
                                    setReloadKey={setReloadKey}
                                    setEditMode={setEditMode}
                                    setSelectedBroker={setSelectedBroker}
                                    selectedBroker={selectedBroker}
                                    canManageBrokers={canManageBrokers}
                                />
                            ) : (
                                <BrokerForm
                                    setEditMode={setEditMode}
                                    selectedBroker={selectedBroker}
                                    canManageBrokers={canManageBrokers}
                                    onSaved={() => setReloadKey((prev) => !prev)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}
